import React, { useState } from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import {
  Section,
  InputField,
  Loading,
  Button,
} from '../components';

function Localization(props) {
  const {
    configData, isSaving, isLoading, saveConfig,
  } = props;

  const [localization, setLocalization] = useState(configData.localization || {});
  const [updated, setUpdated] = useState(false);

  const handleTokenChange = (e, key) => {
    setLocalization({
      ...localization,
      [key]: e.target.value,
    });
    setUpdated(true);
  };

  const saveLocalization = async () => {
    await saveConfig({
      localization,
    });
    setUpdated(false);
  };

  return (
    <Section
      section="bots-localization"
      title="Customize the bot join/remove messages"
      subtitle="Specify the messages using variables as desired:
        {{username}} - bot’s name,
        {{nickname}} - bot’s nickname,
        {{loginname}} - bot’s login name,
        {{email}} - bot’s email.
        Example:  'Bot {{nickname}} joined the conversation'"
      data-testid="bot-localization"
    >
      {isLoading ? <Loading size={24} /> : (
        <Box style={{ maxWidth: 500 }}>
          <InputField
            value={localization.joinBotPhrase}
            handleChange={(e) => handleTokenChange(e, 'joinBotPhrase')}
            inputType="InputField"
            label="Message to send when bot joins conversation"
            data-testid="localization"
            isSaving={isSaving}
          />
          <InputField
            value={localization.removeBotPhrase}
            handleChange={(e) => handleTokenChange(e, 'removeBotPhrase')}
            inputType="InputField"
            label="Message to send when bot is removed from conversation"
            data-testid="localization"
            isSaving={isSaving}
          />

          <Flex>
            <Button
              disabled={!updated || isLoading || isSaving}
              data-testid="save-localization-button"
              variant="primary"
              onClick={saveLocalization}
              mb={3}
            >
              Save
            </Button>
          </Flex>
        </Box>
      )}
    </Section>
  );
}

Localization.defaultProps = {};

Localization.propTypes = {
  configData: PropTypes.object.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  saveConfig: PropTypes.func.isRequired,
};

export default Localization;
